// extracted by mini-css-extract-plugin
export default {"leftSidebar":"rploUQBdL8qhMGBPwXIk","leftSidebarMenu":"tLGXCKq8RgC96Ua2odXY","leftSidebarMenuTop":"EkIOe1pc_6FR9a9E7MIl","leftSidebarIcon":"C24etP_Ytatwrkt14MLu"};